import {User} from '../core/models/user';

export const AVATAR_COLORS = ['#6860fa', '#f59e0b', '#10b981', '#ef4444', '#1b2035'];

export function initials(name: string): string {
  return name.trim().split(/\s+/).slice(0, 2)
    .map(word => word.charAt(0).toUpperCase()).join('') || '?';
}

export function avatarSrc(user: User): string | undefined {
  return user.profileImage
    ? `data:image/jpeg;base64,${user.profileImage}`
    : user.externalProfileImage;
}
